import { Injectable } from '@angular/core';

import { IRRule, RRuleFrequency } from '@azavista/servicelib';
import { EndsOnValue } from './enums';

@Injectable({
    providedIn: 'root'
})
export class RepetitionRulesService {
    sanitizeRRule(rrule: IRRule, endsValue: EndsOnValue): IRRule {
        const clone = { ...rrule };
        if (!clone.until) {
            delete clone.until;
        }
        if (!clone.interval) {
            delete clone.interval;
        }
        if (endsValue === EndsOnValue.never) {
            delete clone.until;
            delete clone.count;
        } else if (endsValue === EndsOnValue.on) {
            delete clone.count;
        } else if (endsValue === EndsOnValue.count) {
            delete clone.until;
        }
        if (!clone.count) {
            delete clone.count;
        }
        if (rrule.frequency === RRuleFrequency.daily) {
            delete clone.bymonthday;
            delete clone.byweekday;
            delete clone.byweekno;
        } else if (rrule.frequency === RRuleFrequency.weekly) {
            delete clone.bymonthday;
            delete clone.byweekno;
        } else if (rrule.frequency === RRuleFrequency.monthly) {
            delete clone.byweekday;
            delete clone.byweekno;
        }
        return clone;
    }
}
